import React from 'react';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { node, string } from 'prop-types';

const SidebarSection = ({ containerClassName, title, children }) => {
  return (
    <Stack spacing={2} className={containerClassName}>
      <Divider />
      <Typography variant="subtitle1" fontWeight="fontWeightBold" color="text.secondary">
        {title}
      </Typography>
      {children}
    </Stack>
  );
};

SidebarSection.propTypes = {
  containerClassName: string,
  title: node
};

export default SidebarSection;
